import { Routes, UrlSegment } from '@angular/router';
import { AuthGuard } from '../core/services/auth.guard';
import { LoginComponent } from './login/login.component';
import { MainComponent } from './main/main.component';
import { BookingStatusComponent } from './booking/booking-status.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', title: 'login', component: LoginComponent },
  {
    matcher: (url) => {
      if (url.length === 1 && url[0].path.match(/^@[\w]+$/gm)) {
        return { consumed: url, posParams: { _id: new UrlSegment(url[0].path.slice(1), {}) } };
      }
      return null;
    },
    title: 'Booking',
    component: BookingStatusComponent,
    data: { hideInNav: false },
    // canActivateChild: [AuthGuard],
  },
  {
    path: 'app', component: MainComponent,
    children: [
      { path: '', redirectTo: 'bookings', pathMatch: 'full' },
      { path: 'bookings', title: 'Bookings', data: { hideInNav: false }, loadComponent: () => import('./booking/booking.component').then(m => m.BookingComponent) },
      { path: 'accounts', title: 'Accounts', data: { hideInNav: false }, loadComponent: () => import('./users/users.component').then(m => m.UsersComponent) },
      { path: 'city', title: 'City', data: { hideInNav: false, }, loadComponent: () => import('./city/city.component').then(m => m.CityComponent) },
      {
        path: 'bookings/add',
        title: 'Bookings',
        loadComponent: () => import('./booking/add-edit-booking.component').then(m => m.AddEditBookingComponent)
      },
      {
        path: 'bookings/edit/:id',
        title: 'Bookings',
        loadComponent: () => import('./booking/add-edit-booking.component').then(m => m.AddEditBookingComponent)
      },
    ],
    canActivateChild: [AuthGuard],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
